import { c as _c } from "react/compiler-runtime";
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ContentText } from './components/ContentText';
import { IntroAPRContainer } from './IntroAPR.container';
export function IntroAPR() {
  const $ = _c(2);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    driverIntroApr
  } = t0;
  const t1 = driverIntroApr?.value;
  let t2;
  if ($[0] !== t1) {
    t2 = <IntroAPRContainer><ContentText>{t1}</ContentText></IntroAPRContainer>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}